// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/radio/Uncontrolled.story.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { Radio, view } from '@sail/ui';
export const Uncontrolled = () => {
  return <view.div css={{
    layout: 'column'
  }}>
      <Radio name="group1" label="Have some of Column A" />
      <Radio name="group1" label="Try all of Column B" />
    </view.div>;
};